/**
 * Resolve authenticated contractor organization labels from
 * /api/auth/organization-access. Never hardcodes a tenant name.
 */
export function resolveOrgLabelsFromAccess(access) {
  const displayName = typeof access?.organizationName === 'string'
    ? access.organizationName.trim()
    : '';
  if (!displayName) {
    return { displayName: 'Your Organization', shortName: 'Org' };
  }
  const shortName = displayName.split(/\s+/)[0] || 'Org';
  return { displayName, shortName };
}
